import { apis2 } from '.';
import http from './http';

export default class OpenChatReportApi {
  static chatRealResponseCountReport (parameter: {
    startDate: string,
    endDate: string,
    seconds: number,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.chatRealResponseCountReport, { parameter })
  }

  static chatCancelCountReport (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.chatCancelCountReport, { parameter })
  }

  static chatResponsePercentageReport (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.chatResponsePercentageReport, { parameter })
  }

  static chatServiceDeskCountReport (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour',
    top: number
  }) {
    return http.post(apis2.OpenChatReportApi.chatServiceDeskCountReport, { parameter })
  }

  static getAvgChatWaitingSeconds (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.getAvgChatWaitingSeconds, { parameter })
  }

  static getMaxChatWaitingSeconds (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.getMaxChatWaitingSeconds, { parameter })
  }

  static getAvgChatSeconds (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.getAvgChatSeconds, { parameter })
  }

  static getAvgChatRoundResponseSeconds (parameter: {
    startDate: string,
    endDate: string,
    groupTime?:null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.getAvgChatRoundResponseSeconds, { parameter })
  }

  static getChatSolvedRate (parameter: {
    startDate: string,
    endDate: string,
    groupTime?: null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.getChatSolvedRate, { parameter })
  }

  static chatStatusCountReport (parameter: {
    startDate: string,
    endDate: string,
    groupTime: 'day' | 'hour', // 按日期分组(预留,后期可以按小时 分钟等) 
    status: ('canceled' | 'linUp' | 'realResponseCount')[]
  }) {
    return http.post(apis2.OpenChatReportApi.chatStatusCountReport, { parameter })
  }

  static listEngineerStatusDistribution (
    page: {
      pageNumber: number,
      pageSize: number
    },
    parameter: {
      seatStatus: null | 'showBusy' | 'online' | 'offline'
    }
  ) {
    return http.post(apis2.OpenChatReportApi.listEngineerStatusDistribution, { page, parameter })
  }

  static countChatRequestLocationDistribution (parameter: {
    startDate: string,
    endDate: string
  }) {
    return http.post(apis2.OpenChatReportApi.countChatRequestLocationDistribution, { parameter })
  }

  static countEngineerStatusDistribution () {
    return http.post(apis2.OpenChatReportApi.countEngineerStatusDistribution, {})
  }

  static chatRequestCountReport (parameter: {
    startDate: string,
    endDate: string,
    groupTime?: null | 'day' | 'hour'
  }) {
    return http.post(apis2.OpenChatReportApi.chatRequestCountReport, { parameter })
  }

  static chatLineUpReport () {
    return http.post(apis2.OpenChatReportApi.chatLineUpReport)
  }
}
